import type React from "react"

import { FieldTooltip } from "@/components/fields/field-tooltip"
import { HStack } from "@/nzds/layout"

import Box from "@mui/material/Box"
import FormHelperText from "@mui/material/FormHelperText"
import FormLabel from "@mui/material/FormLabel"
import Typography from "@mui/material/Typography"

interface ReadonlyFieldProps {
  helperText?: React.ReactNode
  label: string
  tooltipContent?: React.ReactNode
  value: React.ReactNode
}

export const ReadonlyField: React.FC<ReadonlyFieldProps> = ({
  helperText,
  label,
  tooltipContent,
  value,
}) => {
  const hasHelperText = Boolean(helperText)

  return (
    <Box>
      <HStack
        sx={{
          alignItems: "center",
          gap: 0.5,
          mb: hasHelperText ? 0.25 : 0.5,
        }}
      >
        <FormLabel sx={{ mb: 0 }}>{label}</FormLabel>
        {tooltipContent ? <FieldTooltip content={tooltipContent} /> : null}
      </HStack>
      <Typography
        component="div"
        sx={{
          lineHeight: hasHelperText ? 1.5 : "40px",
          mb: hasHelperText ? 0.25 : 0,
        }}
      >
        {value}
      </Typography>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </Box>
  )
}
